import React from "react"
import styled, { keyframes, css } from "styled-components"
import { Transition } from "react-transition-group"
import SlideHeightContext, {
  SlideHeightProvider,
  useSlideHeight,
} from "./SlideHeightContext"
import { useAnimatableLayoutEffect } from "./useAnimatableLayoutEffect"

const onEnter = keyframes`
  0% {
    left: 300%;
  }

  80%{
    left: -4%;
  }
  
  100% {
    left: 0;
  }
`

const onExit = keyframes`
  0% {
    left: 0;
  }

  100% {
    left: -300%;
  }
`

const Pane = styled.div`
  position: absolute;
  top: 0px;
  animation-fill-mode: both;
  width: 100%;
  /* min-height: 50vh; */
  z-index: 32;
  padding: 40px;

  ${props => {
    switch (props.state) {
      case "entering":
        return css`
          animation: ${props => (props.backwards ? onExit : onEnter)} 0.5s
            ease-out;
          animation-fill-mode: both;
          animation-direction: ${props =>
            props.backwards ? "reverse" : "normal"};
        `
      case "entered":
        return css`
          left: 0;
        `
      case "exiting":
        return css`
          animation: ${props => (props.backwards ? onEnter : onExit)} 0.5s
            ease-out;

          animation-fill-mode: both;
          animation-direction: ${props =>
            props.backwards ? "reverse" : "normal"};
        `
      case "exited":
        return css`
          left: ${props => (props.backwards ? "300%" : "-300%")};
        `
      default:
        return css`
          left: -300%;
        `
    }
  }};
`
// This Component makes sure, that the SlidingPane

// Component that takes care of the Sliding Animation for QuestionPanes

export default class SlidingPane extends React.Component {
  static contextType = SlideHeightContext

  state = {
    paneHeight: 0,
    renderedOnce: false,
  }
  componentDidMount() {
    this.setState({ renderedOnce: true })
    this.doSlideHeightUpdate()
  }

  doSlideHeightUpdate() {
    const slideHeightContext = this.context

    if (this.props.visible) {
      if (this.pane?.clientHeight) {
        let paneClientHeight = this.pane?.clientHeight
        this.setState({ paneHeight: paneClientHeight })
        slideHeightContext.updateSlideHeight(paneClientHeight)
      }
    } else if (this.props.visible && this.props.backwards) {
      slideHeightContext.updateSlideHeight(this.state.paneHeight)
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.visible !== this.props.visible ||
      prevProps.backwards !== this.props.backwards
    ) {
      this.doSlideHeightUpdate()
    }
  }

  render() {
    return (
      <React.Fragment>
        <Transition
          in={this.props.visible}
          mountOnEnter={this.state.renderedOnce}
          unmountOnExit={this.state.renderedOnce}
          timeout={500}
        >
          {state => (
            <React.Fragment>
              <Pane
                ref={pane => (this.pane = pane)}
                state={state}
                backwards={this.props.backwards}
                onClick={this.props.onClick}
              >
                {this.props.children}
              </Pane>
            </React.Fragment>
          )}
        </Transition>
      </React.Fragment>
    )
  }
}

// Please leave in-tact. Going to go thru this later.

/*export default function SlidingPane({ backwards, onClick, children, visible }) {
  const { updateSlideHeight } = useSlideHeight()
  const [renderedOnce, setRenderedOnce] = React.useState(false)
  const [paneHeight, setPaneHeight] = React.useState(0)
  const paneRef = React.useRef()

  useAnimatableLayoutEffect(() => {
    if (visible && !backwards) {
      if (paneRef?.current?.clientHeight) {
        let paneClientHeight = paneRef?.current?.clientHeight
        setPaneHeight(paneClientHeight)
        updateSlideHeight(paneClientHeight)
        setRenderedOnce(true)
      }
    } else if (visible && backwards) {
      updateSlideHeight(paneHeight)
    }
  }, [visible, backwards])

  return (
    <>
      <Transition
        in={visible}
        mountOnEnter={renderedOnce}
        unmountOnExit={renderedOnce}
        timeout={500}
      >
        {state => (
          <React.Fragment>
            <Pane
              ref={pane => (this.pane = pane)}
              state={state}
              backwards={backwards}
              onClick={onClick}
            >
              {children}
            </Pane>
          </React.Fragment>
        )}
      </Transition>
    </>
  )
}
*/
